import React, { PureComponent } from 'react';
import style from './styles/style.module.css';

export default class TableBody extends PureComponent {
    render() {
        const { children } = this.props;
        const className = `dl-table-body ${ style.tableBody } ${ this.props.className }`;
        
        return (
            <div className={ className }>
                { children }
            </div>
        );
    }
}
TableBody.defaultProps = {
    className: '',
};
